import { FilterOutlined, SearchOutlined } from '@ant-design/icons';
import { Input, Tag } from 'antd';
import { TableSearchPanel } from 'ui/TableSearchPanel';

export const columns = [
  {
    title: 'Код',
    dataIndex: 'code',
    key: 'code',
  },
  {
    title: 'Наименование области или города',
    dataIndex: 'parent',
    key: 'parent',
    render: (value) => {
      return value?.name_rus ? value.name_rus : '---';
    },
  },
  {
    title: 'Наименование на казахском',
    dataIndex: 'name_kaz',
    key: 'name_kaz',
  },
  {
    title: 'Наименование на русском',
    dataIndex: 'name_rus',
    key: 'name_rus',
    filterDropdown: ({ selectedKeys, setSelectedKeys, confirm }) => {
      return (
        <TableSearchPanel>
          <Input
            autoFocus
            placeholder="Поиск по наименованию"
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              confirm({ closeDropdown: false });
            }}
            onPressEnter={() => confirm()}
          />
        </TableSearchPanel>
      );
    },
    filterIcon: () => <SearchOutlined />,
    onFilter: (value, record) => {
      return record.name_rus.toLowerCase().includes(value.toLowerCase());
    },
  },
  {
    title: 'Статус',
    dataIndex: 'status',
    key: 'status',
    render: (value) => {
      const text = value ? 'Активный' : 'Не активный';
      const color = value ? 'green' : 'red';

      return <Tag color={color}>{text}</Tag>;
    },
    filters: [
      {
        text: 'Не активный',
        value: 0,
      },
      {
        text: 'Активный',
        value: 1,
      },
    ],
    onFilter: (value, record) => record.status === value,
    filterIcon: () => <FilterOutlined />,
  },
];
